import { API } from "../api";
import { isUser, User } from "./_types";
import { BBC_API } from "./types";

const API_VERSION = 'api/v1';

export async function bbcApi({ API }: {
  API: API.Service,
}): Promise<BBC_API.Service> {
  return {
    GET_user: async ({ userId }): Promise<User | undefined> => {
      const user = await API.GET({ endpoint: `${API_VERSION}/users/${userId}` });

      if (!isUser(user)) {
        console.error(`BBC API getExternalUser returned invalid user data for userId ${userId}:`, user);
        return undefined;
      }
      return user;
    },
  };
}
